import { CurrencyMaskDirective } from "./currency-mask.directive";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { CurrencyMaskConfig, DEFAULT_CURRENCY_MASK_CONFIG } from "./currency.config";

@NgModule({
  imports: [CurrencyMaskDirective],
  exports: [CurrencyMaskDirective]
})
export class CurrencyMaskModule {
  static forRoot(config: Partial<CurrencyMaskConfig> = {}): ModuleWithProviders<CurrencyMaskModule> {
    return {
      ngModule: CurrencyMaskModule,
      providers: [
        { provide: 'CURRENCY_MASK_CONFIG', useValue: { ...DEFAULT_CURRENCY_MASK_CONFIG, ...config } }
      ]
    };
  }
}
